"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ComponentProps, MouseEvent } from "react";

const STORAGE_KEY = "landing_utm";

interface TrackedLinkProps extends ComponentProps<typeof Link> {
  trackingLabel?: string;
}

export function TrackedLink({
  onClick,
  trackingLabel,
  children,
  ...props
}: TrackedLinkProps) {
  const pathname = usePathname();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Call existing onClick handler first
    onClick?.(e);

    // Only add tracking overhead if UTMs exist in session
    if (typeof window === "undefined") return;

    try {
      const storedUtms = sessionStorage.getItem(STORAGE_KEY);
      if (!storedUtms) return; // No UTMs = no tracking overhead

      const utmData = JSON.parse(storedUtms);
      const linkText =
        trackingLabel ||
        (typeof children === "string" ? children : String(props.href));

      // Fire tracking event if gtag is available
      if (window.gtag) {
        window.gtag("event", "content_link_click", {
          link_url: props.href,
          link_text: linkText,
          page_path: pathname,
          ...utmData,
        });
      }
    } catch (error) {
      // Silently fail - don't break link functionality
      console.error("Failed to track link click:", error);
    }
  };

  return (
    <Link {...props} onClick={handleClick}>
      {children}
    </Link>
  );
}